import { createContext, useContext } from 'react';

// Actions owned by the Layout shell (dialogs) that pages can trigger.
export interface LayoutActions {
  openExitDialog: () => void;
}

export const LayoutActionsContext = createContext<LayoutActions | null>(null);

export const useLayoutActions = () => useContext(LayoutActionsContext);
